export const formatDate = (date: string): string => {
  const dateObj = new Date(date);

  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Europe/Helsinki", // Finland's time zone
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Use 24-hour format
  };

  return dateObj.toLocaleString("en-GB", options); // English with Finland's time zone
};
